import { sessionStorageService } from './sessionStorageService';

export const getApplicationHeader = () => {
  const sessionToken = sessionStorageService.get<string>('msal.active.token');

  if (sessionToken) {
    return {
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    };
  }

  return null;
};

export const getAuthorizerHeader = () => {
  const sessionToken = sessionStorageService.get<string>('msal.active.token');

  if (sessionToken) {
    return {
      headers: {
        client: 'engineering-management',
        'consumer-key': import.meta.env.APP_AUTHORIZER_CONSUMER_KEY,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
    };
  }

  return null;
};
